import { Component, Inject, OnInit } from '@angular/core';
import { addPersonsInvolved, InspectionVM } from '../../entities/global/model';
import { UsersVM } from '../../perform-induction/perform-induction';
import { SafetyGeneraldashboardService } from '../../services/safety-generaldashboard.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-persons-involved-dialog',
  templateUrl: './persons-involved-dialog.component.html',
  styleUrls: ['./persons-involved-dialog.component.css']
})
export class PersonsInvolvedDialogComponent implements OnInit {

  constructor(public dialogRef:MatDialogRef<PersonsInvolvedDialogComponent>,
    private _safetyGeneraldashboardService: SafetyGeneraldashboardService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

    personsInvolved
    users:UsersVM[]=[]
    originalUsers:UsersVM[]=[]
    FilteredUsers:UsersVM[]=[]
    selectedPersonsInvolved:number[]=[]
    Inspections:InspectionVM
    ispersonInvolvedEmpty:boolean
    UserName
    selectedUserName
  ngOnInit() {
    this.GetUsers();
    this. GetInspectionDetail() 
  }
  DialogClose(){
    this.dialogRef.close(false)
    this. GetInspectionDetail() 
  }

  
  GetInspectionDetail()   
  {
        
    this._safetyGeneraldashboardService.GetInspectionDetail(this.data.InspectionID).subscribe(res=>
      {
        console.log("inspection data", res)
       this.Inspections=res
        // this.workareas=res.WorkArea
        // this.TaskObserved=res.TaskObserved 
        // this.completedDate=res.CompletedDate
        // this.Inspector=res.Inspector
        // this.QuestionCategories=res.QuestionCategories;      
       this.personsInvolved=res.PersonsInvolved
       
      //  this.InspectionVM.map(x=>
      //   {x.PersonsInvolved==res.PersonsInvolved})
      if(res.PersonsInvolved !=null)this.ispersonInvolvedEmpty=true
      else this.ispersonInvolvedEmpty=false

      })
  }

GetUsers()
{
  this._safetyGeneraldashboardService.GetUsersForSafetyApp().subscribe(res=>{
    this.users=res
    this.FilteredUsers =this.users;
    console.log("persons", res)
    res.map(x=>{
      this.UserName=x.UserName
    }
      )
    
    
  })
}

changeModelAutoCompleteAssetSerial(event){
  const filterValue = event.target.value.toLowerCase();
  this.FilteredUsers= this.users;
  if(filterValue.length==0){
    this.FilteredUsers =[];
    this.FilteredUsers= this.users
  }else{
    this.FilteredUsers= this.users.filter(option => option.UserName.toLowerCase().includes(filterValue));
  }
  
  //this.AssetSerialList = this.AssetSerialList_.filter(option => option.Name.toLowerCase().includes(filterValue));
 // this.FilteredUsers = this.users.filter(option => option.UserName.toLowerCase().includes(filterValue));

}
 onPersonsInvolvedChanged(UserAuto, IsAddingUser) {
  this.selectedPersonsInvolved=this.personsInvolved;
  this.selectedUserName=this.UserName
  if(IsAddingUser) {
    console.log(UserAuto)
   
      this.selectedPersonsInvolved.push(UserAuto);
      console.log("pushed arrayee", this.selectedPersonsInvolved);

  } else {
    console.log("else",this.selectedPersonsInvolved.filter(f => f != UserAuto));
      this.selectedPersonsInvolved = this.selectedPersonsInvolved.filter(f => f != UserAuto);
      //this.personsInvolved= this.selectedPersonsInvolved
  }
  console.log("pushed array", this.selectedPersonsInvolved)
  //this.selectedUserName=this.selectedUserName.filter(f => f = UserAuto);
 
  // let checkhasexisitng = this.selectedUserName.find(z => z.id == x.id);
  // console.log("user name", this.UserName)



  
}

save()
{

  
  let model=new addPersonsInvolved();
  model.InspectionID=this.data.InspectionID
  model.selectedPersonsInvolved=this.selectedPersonsInvolved
   console.log("inspection ID",this.data.InspectionID) 
   console.log("array",this.selectedPersonsInvolved) 
this._safetyGeneraldashboardService.SavePersonsInvolved(model).subscribe(res =>{
  
})
  // }) 
 // console.log("persons involved", this.personsInvolved)   
 this.DialogClose();
 this. GetInspectionDetail(); 
}
}
